/**
 * 共通APIクライアント定数
 *
 * AWS Amplify v6のREST APIエンドポイント名を定義
 */

/**
 * APIエンドポイント定数
 *
 * - AUTHENTICATED: 認証済みユーザー用（Authorizationヘッダー自動付与）
 * - PUBLIC: 未認証ユーザー用（認証不要）
 */
export const API_ENDPOINTS = {
  /** 認証済みユーザー用エンドポイント */
  AUTHENTICATED: "authenticated",
  /** 未認証ユーザー用エンドポイント */
  PUBLIC: "public",
};
